import { useInfiniteQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { InfiniteQueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';
import { Filter } from '@/src/util/filters';

import { LibraryItemDTO } from '../types';

const url = `${PREFIX_URL}/library/folders/:folderId/children`;

export type GetFilesResponse = {
  status: boolean;
  data: LibraryItemDTO[];
};

export type GetFilesDTO = {
  folderId: number;
  inTrash?: boolean;
  filter: Filter[];
  page: number;
};

export type GetFilesParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getFilesQueryKey = {
  list: ['getFiles'] as const,
};

const LIST_LIMIT = 20;

export function sanitizeFilter(filter: any) {
  return (
    filter
      // .filter((f) => f.field !== 'tags') // @TODO: temporarily remove tags to avoid BE validation error
      .map((f) => ({
        field: f.field,
        conditions: f.conditions,
      }))
  );
}

export const getFiles = ({ folderId, page, filter }: GetFilesDTO): Promise<GetFilesResponse> => {
  const URL = generateRoutePath(url, { folderId });
  const sanitized = filter ? sanitizeFilter(filter) : [];
  const filterParams =
    Array.isArray(sanitized) && sanitized.length > 0 ? { filter: JSON.stringify(sanitized) } : {};

  const params: GetFilesParams = {
    page,
    limit: LIST_LIMIT,
    ...filterParams,
  };

  return axios.get(URL, { params });
};
type QueryFnType = typeof getFiles;

type UseGetFilesOptions = {
  folderId: number;
  filter: Filter[];
  config?: InfiniteQueryConfig<QueryFnType>;
};

export const useGetFiles = ({ folderId, filter, config }: UseGetFilesOptions) => {
  return useInfiniteQuery({
    queryKey: [...getFilesQueryKey.list, folderId, filter],
    queryFn: ({ pageParam = 1 }) => getFiles({ folderId, page: pageParam, filter }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.data.length === LIST_LIMIT ? allPages.length + 1 : undefined;
    },
    // staleTime: Infinity,
    // cacheTime: 0,
    ...config,
  });
};
